/*!
 * Copyright (C) 2017-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2017-04-19
 *		- Added code for award tickers.
 *		- Hashes now reset on page load if set to display a menu. are not permitted.
 *
 *	2017-07-13
 *		- Removed spanish from the list of languages for Google Translate.
 *
 *	2018-05-08
 *		- Added code to handle flight reservations in the header.
 *
 *	2018-05-23
 *		- Added code to handle live chat display.
 *
 *	2018-06-21
 *		- Added GA tracking to Live Chat Button clicks.
 *
 *	2018-07-23
 *		- Added overlay code.
 *
 *	2018-10-05
 *		- Added DineTime overlay code.
 *
 *	2019-01-29
 *		- Added Peppermill Preferred login dialog code.
 *
 *	2019-02-18
 *		- Updated filter code to handle slash-through pricing with Peppermill Preferred rate data.
 *
 *	2019-03-08
 *		- Updated to track scroll depth in GA.
 *
 *	2019-03-12
 *		- Added code to hide the header and footer (or other UI components if needed) when body form elements are focused.
 *
 *	2019-04-03
 *		- Added code for position:sticky pollyfill.
 *		- Updated filter code to handle hotel widgets as well.
 *		- Moved "reserve-rates" widget code here. Now only used for menu flyouts.
 *
 *	2019-05-20
 *		- Moved Peppermill Preferred login dialog code to separate file.
 *
 *	2020-02-19
 *		- Created window.initTouchPageLinks() function to handle lazy-initializing page link lists for touch devices.
 *
 *	2024-05-09 (jhoward)
 *		- Focus DineTime iframe contents when opening overlay.
 *		- Focus button clicked to open a DineTime overlay when closing overlay.
 */
(function ($) {
	
	var currentScroll	=	0;
	var windowHeight	=	$(window).height();
	
	
	
	
	
	
	var $artwork	=	$('.artwork'),
		$header		=	$('#header'),
		$footer		=	$('#footer'),
		$container	=	$('#container');//,
		//isMinified	=	!/event/.test(function (event) {});
	
	//MENU LINKS
	var menuLinkHistoryUsed	=	false;
	
	function loadMenuPDFFromProxy(menuID) {
		
		if (typeof menuID !== 'string')	menuID	=	$('.iframe-wrapper').find('iframe').data('menu-id');
		
		var win	=	window.open('/library/api/google-drive-pdfs.php?ACTION=VIEW_PDF&FILE_ID=' + encodeURIComponent(menuID));
		
		if (typeof win === 'undefined' || !win) {
			
			window.location			=	'/library/api/google-drive-pdfs.php?ACTION=VIEW_PDF&FILE_ID=' + encodeURIComponent(menuID);
			
		} else {
			
			if ($('.iframe-wrapper').find('.close').length) {
				
				$('.iframe-wrapper')
					.find('.close')
						.trigger('click');
				
			}/* else {
				
				window.location.hash	=	'reset';
				
			}*/
			
			win.focus();
			
		}
		
	}
	
	$(function () {

		ajaxLinkRegisterCallback(
			'MENU-VIEW-PDF',
			loadMenuPDFFromProxy
		);
		
	});
	
	//reset the hash on load if hash set to show a menu
	//if (window.location.hash.replace('#', '').substr(0, 5) === 'menu-')	window.location.hash	=	'';
	
	$(window)
		.on('hashchange.menus', function (event) {
			
			var theHash	=	window.location.hash.replace('#', '');
			
			$('.iframe-wrapper')
				.find('.close')
					.trigger('click', [true]);
			
			if (theHash.substr(0, 5) === 'menu-') {
				
				//make sure there is a matching .menu-link in the DOM
				var menuID		=	theHash.substr(5),
					$btnMatch	=	$('.menu-link').filter('[data-menu-id=' + menuID + ']');
				
				if ($btnMatch.length) {
					
					//match found
					
					event.preventDefault();
					
					if ($('html').hasClass('on-corporate') || !Modernizr.touchevents) {
						
						loadMenuPDFFromProxy($btnMatch.data('menu-id'));
						
					} else {
						
						var $btn			=	($btnMatch.closest('li').length)
													?	$btnMatch.closest('li')
													:	$btnMatch,
							footerHeight	=	($footer.hasClass('above-the-foldstatic'))	?	''	:	$(window).height() - $footer.find('.above-the-fold').offset().top,
							$wrapperEle		=	$('<div class="iframe-wrapper" />')
													.css({
														top			:	0,//$header.height(),
														bottom		:	footerHeight,
														transform	:	'translateX(' + $btn.offset().left + 'px) translateY(' + ($btn.offset().top - $(window).scrollTop() - $header.height()) + 'px) scale(' + ($btn.outerWidth() / $(window).width()) + ', ' + ($btn.outerHeight() / ($(window).height() - $header.height() - footerHeight)) + ')'
													})
													.append(
														$('<iframe data-menu-id="' + $btnMatch.data('menu-id') + '" frameborder="0" src="https://drive.google.com/file/d/' + $btnMatch.data('menu-id') + '/preview" />')
															.on('load', function () {
																
																$(this)
																	.closest('.iframe-wrapper')
																		.addClass('loaded');
																
																clearTimeout($(this).data('loadTimer'));
																
															})
															.data('loadTimer', setTimeout(function () {
																
																//ask to use new proxy
																showOverlayDialog({
																	confirmAccept	:	'DOWNLOAD PDF',
																	confirmDeny		:	'KEEP WAITING',
																	confirmTitle	:	'Problems Loading Menu?',
																	confirmBody		:	'If you are still waiting for the menu to load, you can load the PDF directly by clicking "DOWNLOAD PDF" below.',
																	callback		:	'MENU-VIEW-PDF'
																});
																
															}, 10000))
													)
													.append(
														$('<a class="close" href="#" />').on('click', function (event, hashInitiated) {
															
															if (typeof hashInitiated !== 'boolean')	hashInitiated	=	false;
															
															event.preventDefault();
															
															clearTimeout($wrapperEle.find('iframe').data('loadTimer'));
															
															if (hashInitiated === true) {
																
																setTimeout(function () {
																	
																	$('.iframe-wrapper')
																		.remove();
																	
																	$('html')
																		.removeClass('scrollbar-hide hide-ui');
																	
																	$('body')
																		.height('');
																	
																}, 250);
																
																$('html').removeClass('iframe-wrapper-show');
																
															} else {
																
																if (menuLinkHistoryUsed) {
																	
																	window.history.go(-1);
																	
																	menuLinkHistoryUsed	=	false;
																	
																} else {
																	
																	window.location.hash	=	'reset';
																	
																}
																
															}
															
														})
															.append('<svg width="24" height="24" viewBox="0 0 24 24" class="ic_close_24px" y="72"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>')
													).append(
														'<div class="loader"><svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" enable-background="new 16 15.5 34 65" xml:space="preserve" class="peppermill-loader" height="65px" width="34px" version="1.1" y="0px" x="0px" xmlns:cc="http://creativecommons.org/ns#" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="16 15.5 34 65" xmlns:dc="http://purl.org/dc/elements/1.1/"><path class="body" d="m37.135 69.196c0-1.088-0.62-2.023-1.518-2.503-6.236-16.312-2.125-25.311-1.617-26.314 0.886-0.854 1.29-1.748 1.201-2.657-0.041-0.423-0.188-0.78-0.369-1.083 0.502-0.367 0.832-0.955 0.832-1.622v-0.297c0-0.455-0.158-0.87-0.414-1.208 0.256-0.337 0.414-0.753 0.414-1.208v-0.296c0-0.504-0.193-0.96-0.5-1.313 0.705-1.138 1.078-2.404 1.078-3.703 0-4.375-4.179-7.936-9.313-7.936-5.136 0-9.314 3.561-9.314 7.936 0 1.299 0.373 2.565 1.079 3.702-0.307 0.354-0.5 0.81-0.5 1.314v0.296c0 0.455 0.157 0.871 0.413 1.208-0.256 0.338-0.413 0.753-0.413 1.208v0.297c0 0.667 0.33 1.255 0.832 1.622-0.181 0.303-0.329 0.66-0.37 1.083-0.088 0.909 0.316 1.803 1.202 2.657 0.507 1.003 4.618 10.002-1.617 26.314-0.899 0.479-1.519 1.415-1.519 2.503 0 0.445 0.112 0.861 0.295 1.237h-0.295v9.726h20.413v-9.726h-0.295c0.182-0.375 0.295-0.791 0.295-1.237m-16.928-33.776c-0.218 0-0.403-0.185-0.403-0.403v-0.297c0-0.218 0.185-0.403 0.403-0.403h13.443c0.22 0 0.404 0.185 0.404 0.403v0.297c0 0.218-0.185 0.403-0.404 0.403h-13.443zm-0.403-3.116v-0.296c0-0.198 0.154-0.362 0.346-0.392h13.558c0.19 0.03 0.346 0.194 0.346 0.392v0.296c0 0.218-0.185 0.403-0.404 0.403h-13.443c-0.218 0-0.403-0.186-0.403-0.403m7.125-11.638c4.248 0 7.703 2.838 7.703 6.326 0 1.053-0.321 2.085-0.931 3.007-0.018 0-0.033-0.005-0.052-0.005h-13.442c-0.017 0-0.033 0.005-0.051 0.005-0.61-0.922-0.931-1.954-0.931-3.007 0-3.488 3.456-6.326 7.704-6.326m-5.725 18.816l-0.061-0.106-0.09-0.083c-0.388-0.358-0.841-0.893-0.795-1.408 0.034-0.382 0.33-0.693 0.517-0.855h12.307c0.186 0.16 0.479 0.47 0.517 0.848 0.05 0.517-0.404 1.055-0.795 1.415l-0.089 0.083-0.062 0.106c-0.223 0.385-5.261 9.437 1.113 26.867h-13.676c6.374-17.43 1.337-26.482 1.114-26.867m-2.872 29.714c0-0.448 0.243-0.839 0.601-1.056h15.991c0.358 0.217 0.601 0.607 0.601 1.056 0 0.683-0.555 1.237-1.236 1.237h-14.719c-0.682 0.001-1.238-0.554-1.238-1.237m17.192 9.353h-17.192v-6.505h17.192v6.505z" clip-path="url(#a)"></path><path class="body-top" d="m27.451 20.347c-1.302 0-2.361-1.059-2.361-2.361 0-1.301 1.059-2.36 2.361-2.36s2.36 1.059 2.36 2.36c0 1.303-1.058 2.361-2.36 2.361" clip-path="url(#a)"></path><path class="handle" d="m48.404 17.031h-19.398v1.732h14.979l-1.133 4.363s1.341-0.366 3.508-0.366c2.168 0 3.509 0.366 3.509 0.366l-1.465-6.095z" clip-path="url(#a)"></path><circle class="circle circle-1" cx="20" cy="85" r="1"></circle><circle class="circle circle-2" cx="27" cy="84" r="1"></circle><circle class="circle circle-3" cx="24" cy="89" r="1"></circle><circle class="circle circle-4" cx="35" cy="83" r="1"></circle><circle class="circle circle-5" cx="31" cy="86" r="1"></circle></svg></div>'
													);
						
						$container
							.append($wrapperEle);
						
						setTimeout(function () {
							
							$('body')
								.height($container.height() + $footer.height());
							
							$('html')
								.addClass('iframe-wrapper-show scrollbar-hide hide-ui');
							
							$wrapperEle
								.css({
									transform	:	''
								});
							
						}, 50);
						
					}
					
				}
				
			}
			
		})
		.trigger('hashchange.menus');
	
	$(document)
		.on('click', '.menu-link', function (event) {
			
			event.preventDefault();
			event.stopPropagation();
			
			if (!$('html').hasClass('old-ie')) {
				
				menuLinkHistoryUsed		=	true;
				
			}
			
			window.location.hash	=	'menu-' + encodeURIComponent($(this).data('menu-id'));
			
			//first off check if the user can access google drive, if not just download the PDF
			/*if ($('html').hasClass('on-corporate') || !Modernizr.touchevents) {
				
				event.preventDefault();
				
				loadMenuPDFFromProxy($(this).data('menu-id'));
				
			} else if (!$('html').hasClass('old-ie')) {
				
				event.preventDefault();
				
				window.location.hash	=	'menu-' + encodeURIComponent($(this).data('menu-id'));
				menuLinkHistoryUsed		=	true;
				
			}*/
			
		});
	
	$(document).on('keydown', function (event) {
		
		if (event.which === 27) {
			
			$('#container').children('.iframe-wrapper, .gallery-wrapper').children('.close').trigger('click');
			
		}
		
	});
	
	
	
	
	
	
	
	
	
		
	//floogplan code
	$('#container')
		.find('.right-side-content')
			.find('.floorplan')
				.data('active', false)
				.on('click', function (event) {
					
					event.preventDefault();
					
					var $link	=	$(this);
					
					if ($link.data('active'))	return;

					let $viewport = $link.closest('.viewport');

					if ($viewport.length) {

						$link
							.data('active', true);

						if ($link.closest('.viewport').children('.floorplan-viewport').length) {

							//close
							$link
								.closest('.viewport')
								.children('.floorplan-viewport')
								.removeClass('show');

							setTimeout(function () {

								$link
									.closest('.viewport')
									.children('.floorplan-viewport')
									.remove();

								$link
									.data('active', false);

							}, 350);

						} else {

							//open
							var $floorplanViewport = $('<div class="floorplan-viewport"><a class="close" data-tooltip="Close Floor Plan" href="#"><svg width="24" height="24" viewBox="0 0 24 24" class="ic_close_24px" y="72"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></a><div class="floorplan" style="background-image:url(\'' + $link.attr('href') + '\');"></div><div class="shadow"></div></div>'),
								artworkPosition = $artwork.filter(':visible').eq(0).position(),
								linkPosition = $link.position(),
								artworkSize = {
									width: $artwork.filter(':visible').eq(0).outerWidth(false),
									height: $artwork.filter(':visible').eq(0).outerHeight(false)
								};

							$floorplanViewport
								.css({
									top: artworkPosition.top,
									left: artworkPosition.left,
									width: artworkSize.width,
									height: artworkSize.height,
									transform: 'translateX(' + (linkPosition.left - artworkPosition.left + parseInt($link.css('marginLeft'), 10)) + 'px) translateY(' + (linkPosition.top - artworkPosition.top) + 'px) scale(' + ($link.outerWidth(false) / artworkSize.width * 1.1) + ', ' + ($link.outerHeight(false) / artworkSize.height * 1.1) + ')'
								})
								.find('.close')
								.on('click', function (event) {

									event.preventDefault();

									$link
										.trigger('click');

								});

							$viewport
								.append($floorplanViewport);

							setTimeout(function () {

								$floorplanViewport
									.addClass('show')
									.css({
										transform: ''
									});

								setTimeout(function () {

									$link
										.data('active', false);

									//scroll into view if needed
									let floorPlanBoundingBox = $floorplanViewport[0].closest('.viewport').getBoundingClientRect();
									let headerBoundingBox = document.querySelector('#header').getBoundingClientRect();
									if (floorPlanBoundingBox.top - headerBoundingBox.height < 16) {
										window.scrollTo({
											behavior: 'smooth',
											top: window.scrollY + floorPlanBoundingBox.top - headerBoundingBox.height - 16
										});
									}
								}, 350);

							}, 50);

						}
					} else {
						const floorPlanImageNode = document.querySelector('img.floor-plan');
						if (floorPlanImageNode) {
							//scroll into view if needed
							const floorPlanBoundingBox = floorPlanImageNode.getBoundingClientRect();
							const headerBoundingBox = document.querySelector('#header');
							const headerHeight = (headerBoundingBox) ? headerBoundingBox.getBoundingClientRect().height : 0;
							const pageLinkFilter = document.querySelector('.page-link-filter');
							const pageLinkFilterHeight = (pageLinkFilter) ? pageLinkFilter.getBoundingClientRect().height : 0;
							if (floorPlanBoundingBox.top > window.innerHeight || floorPlanBoundingBox.top - headerHeight - pageLinkFilterHeight < 16) {
								window.scrollTo({
									behavior: 'smooth',
									top: window.scrollY + floorPlanBoundingBox.top - headerHeight - pageLinkFilterHeight - 16
								});
								const anchorNode = floorPlanImageNode.closest('a');
								if (anchorNode && anchorNode.id.length) {
									const idSave = anchorNode.id;
									anchorNode.id = '';
									window.location.hash = idSave;
									anchorNode.id = idSave;
								}
							}
						}
					}
					
				});
	
	
	
	
	
	
	
	
	
	if ($('#google_translate_element').length) {
		
		window.googleTranslateElementInit	=	function () {
			
			new google.translate.TranslateElement({pageLanguage: 'en', includedLanguages: 'en,tl,zh-CN,zh-TW', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, autoDisplay: false, gaTrack: true, gaId: 'UA-31151-1'}, 'google_translate_element');
			
		}
		
		$.getScript('https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
		
	}
	
	
	
	
	
	
	
	
	
	//header award ticker
	/*var awardTickerTimer	=	null,
		awardTickerSpeed	=	50;	//pixels per second
	
	function initializeAwardTicker() {
		
		var awardTickerWidth	=	$('#award-ticker').outerWidth();
		
		$.each($('#award-ticker').find('.ticker-item'), function () {
			
			//set each item so it moves at a constant rage
			var duration	=	parseInt(($(this).find('a').width() + awardTickerWidth) / awardTickerSpeed * 1000);
			
			$(this)
				.data({
					duration	:	duration,
					delay		:	duration / 5
				});
			
		});
		
	}
	
	function resetAwardTicker() {
		
		var $staged	=	$('#award-ticker').find('.ticker-item').filter('.hide');
		
		$staged
			.removeClass('hide active')
			.find('a')
				.css({
					transitionDuration	:	'0ms',
					transform			:	'translateX(' + $('#award-ticker').width() + 'px)'
				});
		
	}
	
	function changeAwardTicker() {
		
		var $current	=	$('#award-ticker').find('.ticker-item').filter('.active');
		
		if ($current.length === 0)	$current	=	$('#award-ticker').find('.ticker-item').eq(-1);
		
		var $next		=	($current.next('.ticker-item').length === 1)	?	$current.next('.ticker-item')	:	$('#award-ticker').find('.ticker-item').eq(0);
		
		$current
			.addClass('hide');
		
		$next
			.addClass('active')
			.find('a')
				.css({
					transitionDuration	:	$next.data('duration') + 'ms',
					transform			:	''
				});
		
		setTimeout(resetAwardTicker, $current.data('delay'));
		
		awardTickerTimer	=	setTimeout(changeAwardTicker, $next.data('duration') / 5 * 4);
		
	}
	
	function runAwardTicker() {
		
		if ($('#award-ticker').find('.ticker-item').length < 2 || $('#award-ticker').data('hovered'))	return;
		
		initializeAwardTicker();
		
		changeAwardTicker();
		
	}
	
	if ($('#award-ticker').length) {
		
		//$('#award-ticker')
		//	.data('hovered', false)
		//	.on('mouseenter', function () {
				
		//		$(this)
		//			.data('hovered', true);
				
		//		clearInterval(awardTickerTimer);
				
		//	})
		//	.on('mouseleave', function () {
				
		//		$(this)
		//			.data('hovered', false);
				
		//		runAwardTicker(false);
				
		//	});
		
		$(function () {
			
			initializeAwardTicker();
			
			runAwardTicker(true);
		
		});
		
	}*/
	
	
	
	
	
	
	
	
	
	
	
	
	//HANDLE AIR-RESERVATIONS IN THE HEADER
	/*var autocompleteLoading				=	false,
		autocompleteAirReservationSetup	=	false,
		allAirportData					=	[],
		closeAirportProximityInKM		=	160,
		$reservationForm				=	$header.find('.pepvalidate-v3').filter('.reservations'),
		$autocompleteEle				=	$reservationForm.find('.reservation-flight-city').find('input'),
		$flightReservationBtn			=	$reservationForm.find('.btn').filter('.flight-reservation'),
		$hotelReservationBtn			=	$reservationForm.find('.btn').filter('.hotel-reservation');
	
	function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
		var R = 6371; // Radius of the earth in km
		var dLat = deg2rad(lat2-lat1);  // deg2rad below
		var dLon = deg2rad(lon2-lon1);
		var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon/2) * Math.sin(dLon/2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		var d = R * c; // Distance in km
		return d;
	}
	
	function deg2rad(deg) {
		return deg * (Math.PI/180);
	}*/
	
	/**
	 *	Determines if $.fn.autocomplete is loaded.
	 *
	 *	@return	boolean	TRUE if loaded, FALSE if not.
	 */
	/*function determineIfAutocompleteLoaded() {
		
		return typeof $.fn.autocomplete === 'function';
		
	}*/
	
	/**
	 *	Load the script necessary for autocomplete functionality.
	 *
	 *	@return	void	N/A
	 */
	/*function loadAutocompleteScript() {
		
		//only load autocomplete if it's not loaded or loading
		if (!autocompleteLoading && !determineIfAutocompleteLoaded() && 'JSON' in window) {
			
			autocompleteLoading	=	true;
			
			$.ajax({
				url			:	'/library/css/jquery-autocomplete.min.css',
				type		:	'get',
				cache		:	true,
				dataType	:	'text',
				success		:	function (response) {
					
					$('html')
						.append('<style>' + response + '</style>');
					
				}
			});
			
			$.ajax({
				url			:	'/library/js/jquery-autocomplete.min.js',
				type		:	'get',
				cache		:	true,
				dataType	:	'script',
				success		:	function () {
					
					var counter					=	0,
						interval				=	250,
						max						=	3500,
						autocompleteInterval	=	setInterval(function () {
							
							counter++;
							
							if (determineIfAutocompleteLoaded() || counter * interval > max) {
								
								clearInterval(autocompleteInterval);
								
								setupHeaderAirReservationAutocomplete();
								
							}
							
						}, interval);
					
				}
			});
			
		} else if (determineIfAutocompleteLoaded() && !$flightReservationBtn.hasClass('btn-dark')) {
			
			findAllAirports();
			//findClosestAirports();
			
		}
		
	}
	
	function filterCloseAirports(lng, lat, proximity) {
		
		var output	=	[];
		
		for (var i = 0, l = allAirportData.length; i < l; i++) {
			
			if (proximity > getDistanceFromLatLonInKm(lat, lng, allAirportData[i].data.lat, allAirportData[i].data.lng)) {
				
				output.push(allAirportData[i]);
				
			}
			
		}
		
		return output;
		
	}
	
	function createSelectableListOfAirports(airports) {
		
		if (airports.length) {
			
			var $suggestionListEle		=	$('<div class="autocomplete-suggestions autocomplete-custom" style="position:absolute; max-height: 300px; z-index: 9998; top: ' + ($autocompleteEle.offset().top + $autocompleteEle.outerHeight()) + 'px; left: ' + $autocompleteEle.offset().left + 'px; width: ' + $autocompleteEle.outerWidth() + 'px;"></div>');
			
			for (var i = 0, l = airports.length; i < l; i++) {
				
				if (typeof airports[i].data.isGroup === 'boolean' && airports[i].data.isGroup) {
					
					$suggestionListEle
						.append('<div class="autocomplete-group" style="text-align:center;font-size:1.1em;font-weight:bold;padding:6px 0;">' + airports[i].value + '</div>');
					
				} else if (typeof airports[i].data.isSpacer === 'boolean' && airports[i].data.isSpacer) {
					
					$suggestionListEle
						.append('<div class="autocomplete-group">' + airports[i].value + '</div>');
					
				} else {
					
					$suggestionListEle
						.append('<div class="autocomplete-suggestion">' + airports[i].value + '</div>');
					
				}
			}
			
			$suggestionListEle
				.children()
					.on('click', function (event) {
						
						if ($(this).hasClass('autocomplete-suggestion')) {
							
							$autocompleteEle
								.val($(this).text())
								.trigger('change');
							
						}
						
					});
			
			return $suggestionListEle;
			
		}
		
		return false;
		
	}
	
	function displayAllAirports(lng, lat) {
		
		var $suggestionListEle	=	false,
			localAllAirportData	=	allAirportData,
			closeAirports		=	[];
		
		if (localAllAirportData.length) {
			
			//add nearby airports to the top of the list
			if (typeof lng === 'number' && typeof lat === 'number') {
				
				closeAirports	=	filterCloseAirports(lng, lat, closeAirportProximityInKM);

				if (closeAirports.length === 0)	closeAirports	=	filterCloseAirports(lng, lat, closeAirportProximityInKM * 2);
				
				if (closeAirports.length) {
					
					localAllAirportData.unshift({
						value	:	' - All Airports - ',
						data	:	{
							isGroup	:	true
						}
					});
					
					localAllAirportData.unshift({
						value	:	'&nbsp;',
						data	:	{
							isSpacer	:	true
						}
					});
					
					$.each(closeAirports, function (i) {
						
						localAllAirportData.unshift(closeAirports[i]);
						
					});
					
					localAllAirportData.unshift({
						value	:	' - Nearby Airports - ',
						data	:	{
							isGroup	:	true
						}
					});
					
				}
				
			}
			
			$suggestionListEle	=	createSelectableListOfAirports(localAllAirportData);
			
			if ($suggestionListEle !== false)	$('body').append($suggestionListEle);
			
		}
		
	}*/
	
	/**
	 *	Selects a list of airports close to a specified location.
	 *
	 *	@param	lng		float	Longitude to search from.
	 *	@param	lat		float	Latitudeto search from.
	 *	@param	$ele	object	jQuery object for the matched autocomplete element(s).
	 */
	/*function displayCloseAirports(lng, lat) {
		
		var currentAirportSelection	=	$autocompleteEle.val(),
			closeAirports			=	(typeof lng === 'number' && typeof lat === 'number')	?	filterCloseAirports(lng, lat, closeAirportProximityInKM)	:	allAirportData,
			$suggestionListEle		=	false;
		
		//double the radius if nothing is found
		if (closeAirports.length === 0)	filterCloseAirports(lng, lat, closeAirportProximityInKM * 2);
		
		if (closeAirports.length) {
			
			$suggestionListEle	=	createSelectableListOfAirports(closeAirports);
			
			if ($suggestionListEle !== false)	$('body').append($suggestionListEle);
			
		}
		
	}
	
	function findAllAirports() {
		
		//try to offer a list of cities in the user's state
		if (location.hostname === 'dev.peppermillreno.com') {
			
			//test location data
			displayAllAirports(-119.7310213, 39.483564699999995);
			
		} else if ('geolocation' in navigator) {
			
			navigator
				.geolocation
					.getCurrentPosition(function (position) {
						
						displayAllAirports(position.coords.longitude, position.coords.latitude);
						
					});
			
		}
		
	}
	
	function findClosestAirports() {
		
		//try to offer a list of cities in the user's state
		if (location.hostname === 'dev.peppermillreno.com') {
			
			//test location data
			displayCloseAirports(-119.7310213, 39.483564699999995);
			
		} else if ('geolocation' in navigator) {
			
			navigator
				.geolocation
					.getCurrentPosition(function (position) {
						
						displayCloseAirports(position.coords.longitude, position.coords.latitude);
						
					});
			
		}
		
	}*/
	
	/**
	 *	Setup autocomplete functionality for air reservations in the header.
	 *
	 *	@return	void	N/A
	 */
	/*function setupHeaderAirReservationAutocomplete() {
		
		if (!autocompleteAirReservationSetup) {
			
			autocompleteAirReservationSetup	=	true;
			
			$.ajax({
				url			:	'/library/json/airports-header.json',
				type		:	'get',
				cache		:	true,
				dataType	:	'json',
				success		:	function (response) {
					
					//cache data for later use
					allAirportData	=	response;
					
					//setup autocomplete
					$autocompleteEle
						.autocomplete({
							lookup				:	response,
							forceFixPosition	:	true,
							noSuggestionNotice	:	true,
							onSelect			:	hideAutocompletes,
							beforeRender		:	hideAutocompletes
							//appendTo	:	$autocompleteEle.closest('p')
						});
					
					findAllAirports();
					//findClosestAirports();
					
				}
			});
			
		}
		
	}
	
	function hideAutocompletes() {
		
		$('body')
			.children('.autocomplete-custom')
				.remove();
		
		if (determineIfAutocompleteLoaded() && $autocompleteEle.length) {
			
			$autocompleteEle
				.autocomplete()
					.hide();
			
		}
		
	}
	
	$flightReservationBtn
		.on('click', function (event) {
			
			event.preventDefault();
			
			if (!$flightReservationBtn.hasClass('btn-dark'))	return;
			
			$flightReservationBtn
				.removeClass('btn-dark');
			
			$hotelReservationBtn
				.addClass('btn-dark');
			
			$reservationForm
				.addClass('flight-reservation')
				.removeClass('hotel-reservation')
				.find('input[name=reservation_type]')
					.val('ReservHotel');
			
			$autocompleteEle
				.focus()
				.select();
			
			loadAutocompleteScript();
			
		});
	
	$hotelReservationBtn
		.on('click', function (event) {
			
			event.preventDefault();
			
			if (!$hotelReservationBtn.hasClass('btn-dark'))	return;
			
			$hotelReservationBtn
				.removeClass('btn-dark');
			
			$flightReservationBtn
				.addClass('btn-dark');
			
			$reservationForm
				.addClass('hotel-reservation')
				.removeClass('flight-reservation')
				.find('input[name=reservation_type]')
					.val('ResNet');
			
			hideAutocompletes();
			
		});
	
	if ($autocompleteEle.length) {
		
		window
			.addEventListener('scroll', function (event) {
				
				hideAutocompletes();
				
			}, {
				passive	:	true
			});
		
		$(document)
			.on('click', function () {
				
				hideAutocompletes();
				
			});
		
	}*/
	
	
	
	
	
	
	
	
	
	
	
	
	//LIVE CHAT FUNCTIONALITY
	var liveChatCacheTTL		=	300000,
		liveChatCacheKey		=	'live-chat-data',
		$liveChatBtn			=	$("#live-chat-btn"),
		liveChatScroll			=	-1,
		liveChatScrollThreshold	=	Math.min(parseInt($(window).height() / 2,10)),
		liveChatResizeTimer		=	null;
	
	function checkLiveChatScroll() {
		
		if($(this).scrollTop() > liveChatScrollThreshold) {
			
			$liveChatBtn
				.removeClass("live-chat-hide");
			
			pepTracking.event('Live Chat', 'Live Chat Button Shown');
			
		} else {
			
			requestAnimationFrame(checkLiveChatScroll);
			
		}
		
	}
	
	function activateLiveChat() {
		
		if ($container.hasClass('no-artwork') || $container.hasClass('content-page')) {
			
			$liveChatBtn
				.removeClass("live-chat-hide");
			
			pepTracking.event('Live Chat', 'Live Chat Button Shown');
			
		} else {
			
			if ('addEventListener' in window) {
				
				window
					.addEventListener('scroll', function () {
						
						liveChatScroll	=	$(window).scrollTop();
						
					}, {
						passive	:	true
					});
				
				window
					.addEventListener('resize', function () {
						
						clearTimeout(liveChatResizeTimer);
						
						liveChatResizeTimer	=	setTimeout(function () {
							
							liveChatScrollThreshold	=	parseInt($(window).height() / 2,10);
							
						}, 33);
						
					});
				
			} else {
				
				window
					.onscroll	=	function () {
						
						liveChatScroll	=	$(window).scrollTop();
						
					};
				
				window
					.onresize	=	function () {
						
						clearTimeout(liveChatResizeTimer);
						
						liveChatResizeTimer	=	setTimeout(function () {
							
							liveChatScrollThreshold	=	parseInt($(window).height() / 2,10);
							
						}, 33);
							
					};
				
			}
			
			$(checkLiveChatScroll);
			
		}
		
		$liveChatBtn
			.on("click",function (event) {
				
				event.preventDefault();
				
				pepTracking.event('Live Chat', 'Live Chat Button Clicked');
				
				try {
					
					var newWindow	=	window.open(this.href, "Peppermill Live Chat", "height=600,width=400,menubar=no,toolbar=no,location=no,personalbar=no,resizable=yes,status=yes,scrollbars=yes");
					
					//newWindow.opener	=	null;
					
				} catch (e) {
					
					pepTracking.event('JS Error', 'Live Chat', e.message, 0, true);
					
					$.ajax({
						url			:	'/library/api/capture-js-error.php',
						dataType	:	'json',
						type		:	'post',
						data		:	{
							je_message	:	e.message,
							je_source	:	'https://www.peppermillreno.com/library/js/lazy.min.js',
							je_lineno	:	0,
							je_colno	:	0,
							je_url		:	window.location.href,
							je_stack	:	e
						}
					});
					
				}
				
			});
		
	}
	
	function getLiveChatDataCache() {
		
		if (Modernizr.localstorage && 'JSON' in window) {
			
			var liveChatDataString	=	localStorage.getItem(liveChatCacheKey),
				liveChatDataObject	=	{};
			
			if (liveChatDataString) {
				
				try {
					
					liveChatDataObject	=	JSON.parse(liveChatDataString);
					
					return liveChatDataObject;
					
				} catch (e) {
					
					pepTracking.event('JS Error', 'Live Chat', e.message, 0, true);
					
					$.ajax({
						url			:	'/library/api/capture-js-error.php',
						dataType	:	'json',
						type		:	'post',
						data		:	{
							je_message	:	e.message,
							je_source	:	'https://www.peppermillreno.com/library/js/lazy.min.js',
							je_lineno	:	0,
							je_colno	:	0,
							je_url		:	window.location.href,
							je_stack	:	e
						}
					});
					
				}
				
			}
			
		}
		
		return false;
		
	}
	
	/**
	 *	Determine if fresh live chat data needs to be requested.
	 *
	 *	@return	boolean	TRUE if data needs to be updated, FALSE if not.
	 */
	function checkLiveChatDataCache() {
		
		var liveChatDataObject	=	getLiveChatDataCache();
		
		if (liveChatDataObject !== false && liveChatDataObject.ts > new Date().getTime() - liveChatCacheTTL) {
			
			return false;
			
		}

		return true;
		
	}
	
	if ($liveChatBtn.length) {
		
		if (checkLiveChatDataCache()) {
			
			$.ajax({
				url			:	'/library/api/live-chat.php',
				type		:	'post',
				dataType	:	'json',
				data		:	{
					ACTION	:	'CHECK_AVAILABLE'
				},
				success		:	function (response) {
					
					if (Modernizr.localstorage && 'JSON' in window) {
						
						localStorage.setItem(liveChatCacheKey, JSON.stringify({
							ts			:	new Date().getTime(),
							available	:	(response.STATUS === 'SUCCESS')
						}));
						
					}
					
					if (response.STATUS === 'SUCCESS') {
						
						activateLiveChat();
						
					}
					
				},
				error		:	function (jqXHR, textStatus, errorThrown) {
					
					//log this error
					var extraText	=	(typeof errorThrown === 'string')
											?	' -- ' + errorThrown
											:	'';
					pepTracking.event('JS Error', 'Live Chat', textStatus + extraText, 0, true);
					
					$.ajax({
						url			:	'/library/api/capture-js-error.php',
						dataType	:	'json',
						type		:	'post',
						data		:	{
							je_message	:	'Live Chat',
							je_source	:	'https://www.peppermillreno.com/library/js/lazy.min.js',
							je_lineno	:	0,
							je_colno	:	0,
							je_url		:	window.location.href,
							je_stack	:	"Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
						}
					});
					
				}
			});
			
		} else {
			
			//check if the live chat button should be shown based on cached data
			
			var liveChatDataObject	=	getLiveChatDataCache();
			
			if (liveChatDataObject !== false && liveChatDataObject.ts > new Date().getTime() - liveChatCacheTTL && !!liveChatDataObject.available === true) {
				
				activateLiveChat();
				
			}
			
		}
		
	}
	
	
	
	
	
	
	
	
	
	
	//OVERLAY CODE
	$('#overlay')
		.on('click', function () {
			
			window.hideLoader(true, false);
			
		});
	
	
	
	
	
	
	
	
	
	
	//DINETIME OVERLAY CODE
	require('./helpers/DineTimeWidget');

	
	
	
	
	
	
	
	

	

	
	
	
	
	
	//HANDLE horizontal scroll indicators
	window.initTouchPageLinks	=	function ($bodyContainers) {
		
		if (Modernizr.touchevents) {
			
			if ('object' !== typeof $bodyContainers) {
				
				var $bodyContainers	=	$('.body-container').filter('.page-links');
				
			}
			
			$bodyContainers
				.children('.viewport')
					.off('scroll.hscroll')
					.one('scroll.hscroll', function () {
						
						$(this)
							.closest('.page-links')
								.addClass('scrolled');
						
					})
					.off('click.hscroll')
					.on('click.hscroll', function (event) {
						
						if (event.target === this) {
							
							$(this)
								.off('click.hscroll');
							
							if (!$(this).closest('.page-links').hasClass('scrolled') && 1 < $(this).find('.item').not('.hide').length) {
								
								$(this)
									.animate({ scrollLeft : $(this).find('.item').not('.hide').eq(0).outerWidth() + parseInt($(this).css('padding-left'), 10) }, 250, 'easeInOutCubic')
									.closest('.page-links')
										.addClass('scrolled');
								
							}
							
						}
						
					});
			
		}
		
	};
	
	initTouchPageLinks();
	
	
	
	
	
	
	
	
	
	
	
	
	
	//TRACK SCROLL DEPTH
	function calculateScrollableHeight () {
		
		return $container.outerHeight(true) - $(window).height();
		
	}
	
	function checkScrollBreakpoints() {
		
		if (true === forceScrollBreakpointRecalc) {
			
			forceScrollBreakpointRecalc	=	false;
			
			maxScrollHeight	=	calculateScrollableHeight();
			
		}
		
		var currentScrollPercent	=	$(document).scrollTop() / maxScrollHeight;
		
		for (var i = 0, l = scrollBreakpointsPercent.length; i < l; i++) {
			
			if (scrollBreakpointsPercent[i] < currentScrollPercent && -1 === scrollBreakpointsTriggered.indexOf(scrollBreakpointsPercent[i])) {
				
				//we've passed a breakpoint that has not yet been reported
				pepTracking.event('Scroll Depth', (scrollBreakpointsPercent[i] * 100) + '%', '', 0, true);
				
				scrollBreakpointsTriggered.push(scrollBreakpointsPercent[i]);
				
			}
			
		}
		
	}
	
	var scrollBreakpointsPercent	=	[0.25, 0.5, 0.75, 0.95];
	var maxScrollHeight				=	calculateScrollableHeight();
	var scrollBreakpointTimer		=	null;
	var scrollBreakpointsTriggered	=	[];
	var forceScrollBreakpointRecalc	=	false;
	
	$(window)
		.on('load.scrollBreakpoints resize.scrollBreakpoints', function () {
			
			clearTimeout(scrollBreakpointTimer);
			
			scrollBreakpointTimer	=	setTimeout(function () {

				windowHeight				=	$(window).height();
				forceScrollBreakpointRecalc	=	true;
				
			}, 66);
			
		});
	
	
	
	document
		.addEventListener('scroll', function () {
			
			currentScroll	=	$(document).scrollTop();
			
		}, {
			passive	:	true
		});
	
	
	
	
	
	
	
	
	
	

	//polyfill position:sticky elements if needed
	if (!Modernizr.csspositionsticky) {
		
		var $stickyPolyfillElements	=	$('.sticky-polyfill');
		var stickyTimer				=	null;
		
		if ($stickyPolyfillElements.length) {
			
			$.getScript('/library/js/stickyfill.min.js', function () {
				
				//we can't be sure that the script has been parsed yet
				//	so we make sure it has before trying to use it
				stickyTimer	=	setInterval(function () {
					
					if ('Stickyfill' in window) {
						
						clearInterval(stickyTimer);
						
						for (var i = 0, l = $stickyPolyfillElements.length; i < l; i++) {
							
							Stickyfill.add($stickyPolyfillElements[i]);
							
						}
						
					}
					
				}, 500);
				
			});
			
		}
		
	}
	
	
	
	
	
	
	
	
	

	
	
	
	
	
	
	
	
	
	/*SETUP HOTEL RATE FLYOUT BUTTONS*/
	var reserveRatesLiHeight	=	$('.reserve-rates').eq(0).find('.display').height();
	
	$(document)
		.on('click', function () {
			
			$container
				.find('.reserve-rates')
					.removeClass('show');
			
		});
	
	$(window)
		.on('load resize', function () {
			
			reserveRatesLiHeight	=	$('.reserve-rates').eq(0).find('.display').height();
			
		});
	
	function initReserveRates() {
		
		var $rateBtn	=	$(this);
		
		if ($rateBtn.data('initialized'))	return;
		
		$rateBtn
			.data({
				initialized	:	true,
				clickOK		:	true,
				clickTimer	:	null,
				hoverTimer	:	null
			})
			.on('reset', function () {
				
				$(this)
					.children('.flyout')
						.find('li')
							.eq(0)
								.trigger('click', [true]);
				
			})
			.on('mouseenter', function () {
				
				$rateBtn
					.removeClass('hide')
					.data({
						clickOK		:	false,
						clickTimer	:	setTimeout(function () {
							
							$rateBtn
								.data('clickOK', true);
							
						}, 250)
					});
				
			})
			.on('mouseleave', function () {
				
				if (!Modernizr.touchevents) {
					
					clearTimeout($rateBtn.data('hoverTimer'));
					
					$(this)
						.closest('.reserve-rates')
							.removeClass('show');
					
				}
				
			})
			.children('.display')
				.on('mouseenter', function () {
					
					if (!Modernizr.touchevents) {
						
						var $display	=	$(this);
						
						clearTimeout($rateBtn.data('hoverTimer'));
						
						$rateBtn
							.data('hoverTimer', setTimeout(function () {
								
								$display
									.trigger('click.reserve-rates');
								
							}, 150));
						
					}
					
				})
				.on('click.reserve-rates', function (event) {
					
					event.stopPropagation();
					
					//only if a link does not exist
					if ($(this).find('a').length === 0) {

						//open this flyout, close all others in this set
						$(this)
							.closest('.reserve-rates')
								.addClass('show')
								.closest('.item')
									.siblings('.hotel')
										.find('.reserve-rates')
											.removeClass('show');
						
					}
					
				})
			.end()
			.children('.flyout')
				.css({
					transform	:	'translateY(' + (-1 * reserveRatesLiHeight * ($rateBtn.find('.flyout').find('.selected').index() + 1)) + 'px)'
				})
				.find('li')
					.on('click', function (event, forceClick) {
						
						event.stopPropagation();
						
						if (typeof forceClick !== 'boolean')	var forceClick	=	false;
						
						var $selected	=	$(this),
							$display	=	$rateBtn.children('.display');
						
						if (!forceClick && !$rateBtn.data('clickOK'))	return;
						
						if (!forceClick) {
							
							$rateBtn
								.data({
									clickOK		:	false,
									clickTimer	:	setTimeout(function () {
										
										$rateBtn
											.data('clickOK', true);
										
									}, 350)
								});
							
						}
						
						//only do work if the value changed
						if ($selected.data('value') !== $display.data('value')) {
							
							//update .selected
							$selected
								.addClass('selected')
									.siblings()
										.removeClass('selected');
							
							
							
						}
						
					})
					.find('a')
						.on('click', function (event) {
							
							if ($rateBtn.hasClass('menus')) {
								
								pepTracking.event('Menu Click', $('h1').text(), $(this).text(), 0, true);
								
							} else if ($(this).closest('li').hasClass('special-offer') && event.offsetX > $(this).width() - 24) {
								
								showOverlayDialog({
									alertMode				:	true,
									confirmAccept			:	'OK',
									confirmTitle			:	'Special Offer',
									confirmBody				:	'This room rate is based on a special offer available in your Online Players Club account.'
								});
								
								event.preventDefault();
								event.stopPropagation();
								
							} else {
								
								//get title of this room
								var title	=	($rateBtn.closest('.item').length)
													?	$rateBtn.closest('.item').find('h3').text()
													:	$('h1').text();
								
								pepTracking.event('Reservations Room Rate Click', title, '', 0, true);
								
							}
							
						});
		
	}
	
	$.each($container.find('.reserve-rates'), initReserveRates);
	
	
	
	
	
	
	
	
	
	
	//Outlet Hours API
	var $pageLinks			=	$('.body-container').filter('.page-links').find('.item');
	var requestOutletHours	=	!!$pageLinks.filter(function () {
			
			return $(this).closest('.page-links').not('.homepage').not('.related-events').length;
			
		}).length;
	
	function parseOutletHourAPIResponse(response, cacheOutletHoursResponse) {
		
		if (typeof cacheOutletHoursResponse === 'undefined')	var cacheOutletHoursResponse	=	true;
		
		if (response.STATUS === 'SUCCESS') {
			
			//add "Open Now" or "Open Later" to the .right-side-content element -- DISABLED
			/*var currentPageID	=	$('body').data('i'),
				pageFound		=	false;
			
			if ($.inArray($('body').data('i'), response.OPEN_NOW.PAGES) > -1) {
				
				$('h1')
					.append('<span class="open-now">Open Now</span>');
				
			} else if ($.inArray($('body').data('i'), response.OPEN_LATER.PAGES) > -1) {
				
				$('h1')
					.append('<span class="open-later">Opens Later</span>');
				
			}*/
			
			//add to .page-link .item elements
			$.each($pageLinks, function (i) {
				
				if ($.inArray($pageLinks.eq(i).data('page-id'), response.OPEN_NOW.PAGES) > -1) {
					
					$pageLinks
						.eq(i)
							.find('.item-body')
								.prepend('<span class="open-now">Open Now</span>');
					
				} else if ($.inArray($pageLinks.eq(i).data('page-id'), response.OPEN_LATER.PAGES) > -1) {
					
					$pageLinks
						.eq(i)
							.find('.item-body')
								.prepend('<span class="open-later">Opens Later</span>');
					
				}
				
			});
			
		}
		
		if ('JSON' in window && Modernizr.localstorage && cacheOutletHoursResponse) {
			
			var cacheString	=	JSON.stringify({
				endOfLife	:	new Date().getTime() + 300000,
				response	:	response
			});
			
			try {
				
				localStorage.setItem('outletHoursAPI', cacheString);
				
			} catch (e) {}
			
		}
		
	}
	
	//check for cached data that's current enough to display
	if (requestOutletHours && 'JSON' in window && Modernizr.localstorage && typeof localStorage.getItem('outletHoursAPI') === 'string') {
		
		var outletHoursCache	=	$.parseJSON(localStorage.getItem('outletHoursAPI'));
		
		if (parseInt(outletHoursCache.endOfLife, 10) > new Date().getTime()) {
			
			requestOutletHours	=	false;
			
			parseOutletHourAPIResponse(outletHoursCache.response, false);
			
		} else {
			
			//remove from cache since the data is old
			localStorage.removeItem('outletHoursAPI');
			
		}
		
	}
	
	if (requestOutletHours) {
		
		$.ajax({
			url			:	'/library/api/outlet-hours.php',
			type		:	'post',
			dataType	:	'json',
			success		:	parseOutletHourAPIResponse,
			error		:	function (jqXHR, textStatus, errorThrown) {
				
				//log this error
				var extraText	=	(typeof errorThrown === 'string')
										?	' -- ' + errorThrown
										:	'';
				pepTracking.event('JS Error', 'Outlet Hours AJAX', textStatus + extraText, 0, true);
				
				$.ajax({
					url			:	'/library/api/capture-js-error.php',
					dataType	:	'json',
					type		:	'post',
					data		:	{
						je_message	:	'Outlet Hours AJAX Failure',
						je_source	:	'https://www.peppermillreno.com/library/js/main.min.js',
						je_lineno	:	0,
						je_colno	:	0,
						je_url		:	window.location.href,
						je_stack	:	"Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
					}
				});
				
			}
		});
		
	}
	
})(jQuery);









/*! jQuery requestAnimationFrame - v0.1.2 - 2013-04-15
* https://github.com/gnarf37/jquery-requestAnimationFrame
* Copyright (c) 2013 Corey Frang; Licensed MIT */
(function(e){function o(){t&&(i(o),jQuery.fx.tick())}var t,n=0,r=["webkit","moz"],i=window.requestAnimationFrame,s=window.cancelAnimationFrame;for(;n<r.length&&!i;n++)i=window[r[n]+"RequestAnimationFrame"],s=s||window[r[n]+"CancelAnimationFrame"]||window[r[n]+"CancelRequestAnimationFrame"];i?(window.requestAnimationFrame=i,window.cancelAnimationFrame=s,jQuery.fx.timer=function(e){e()&&jQuery.timers.push(e)&&!t&&(t=!0,o())},jQuery.fx.stop=function(){t=!1}):(window.requestAnimationFrame=function(e,t){var r=(new Date).getTime(),i=Math.max(0,16-(r-n)),s=window.setTimeout(function(){e(r+i)},i);return n=r+i,s},window.cancelAnimationFrame=function(e){clearTimeout(e)})})(jQuery);
